module.exports = __webpack_public_path__ + "img/password.1c89166f.svg";